<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">
      <!--site header begins-->

      <section class="admin-content">
      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex flex-wrap align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-user" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Welcome, {{ user.firstname }}</h4>
              <small style="opacity: .8;">Your enrollees and facilities at a glance</small>
            </div>
          </div>
        </div>
      </div>
        <div class="container mt-n3 pb-5">
          <div class="row">

            <div class="col-lg-4 col-md-4">
              <div class="card table-card shadow mb-4">
                <div class="card-body">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <div class="avatar-title bg-soft-primary rounded-circle">
                        <i class="fe fe-user"></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-muted text-overline m-0">Welcome,</p>
                    <h1 class="fw-400">Dear {{ user.firstname }}</h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-4">
              <div class="card table-card shadow mb-4">
                <div class="card-body">
                  <div class="pb-2">
                    <router-link :to="{ path: '/manage-clients' }">
                      <div class="avatar avatar-lg">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-users"></i>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div>
                    <p class="text-muted text-overline m-0">Total Enrollees</p>
                    <h1 class="fw-400">
                      {{ clients.meta.total | numeral(0, 0) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-4">
              <div class="card table-card shadow mb-4">
                <div class="card-body">
                  <div class="pb-2">
                    <router-link :to="{ path: '/manage-clients' }">
                      <div class="avatar avatar-lg">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-users"></i>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div>
                    <p class="text-muted text-overline m-0">My Enrollees</p>
                    <h1 class="fw-400">
                      {{ enrollee_clients.meta.total | numeral(0, 0) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <informallga />

          <div class="row">
            <div class="col-md-12 m-b-30">
              <!-- <h5> <i class="fe fe-alert-circle"></i>{{clients.length}} CLients</h5> -->
              <div class="table-responsive">
                <table class="table align-td-middle table-card">
                  <thead style="background: #f8fafc;">
                    <tr>
                      <th class="table-th">Name</th>
                      <th class="table-th">Phone Number</th>
                      <th class="table-th">Sector</th>
                      <th class="table-th">ZAMCHEMA Number</th>
                      <!-- <th class="table-th">Facility</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="client in clients.data" v-bind:key="client.id">
                      <td>
                        {{ client.full_name }}
                      </td>
                      <td>{{ client.phone_number }}</td>
                      <td>{{ client.sector }}</td>
                      <td>{{ client.id_card_number }}</td>
                      <!-- <td>{{client.provider_id}}</td> -->

                      <td>
                        <router-link :to="{ path: '/client/' + client.id }">
                          <button
                            type="button"
                            name="button"
                            class="btn btn-info"
                          >
                            view
                          </button>
                        </router-link>
                      </td>
                    </tr>
                    <div class="vld-parent">
                      <loading
                        :active.sync="isLoading"
                        loader="spinner"
                        :can-cancel="false"
                        :is-full-page="true"
                      ></loading>
                    </div>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </main>
  </div>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import Footer from "@/views/Footer.vue";
import informallga from "@/views/shis/component/informallga.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Navbar,
    informallga,
    Footer,
    Loading,
  },

  data() {
    return {
      auth_user: "",
      user: null,
      clients: "",
      enrollee_clients: "",
      selected_lga: "",
      facilities: "",
      wards: "",
      isLoading: false,
      show: false,
      fullPage: true,
      lga_states: true,
    };
  },
  beforeMount() {
    this.axios
      .get(`/api/v1/auth/user`)
      .then((response) => {
        this.auth_user = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  methods: {
    myEnrollees() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/employee_client/${this.user.id}`)
        .then((response) => {
          this.enrollee_clients = response.data;
          this.isLoading = false;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    fetchFacilitiesperlga() {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/auth/getProviderPerLGA/${this.selected_lga.id}`)
        .then((response) => {
          this.facilities = response.data.data;
          console.log(response);

          //get wards
          this.axios
            .get(`/api/v1/auth/getwards/${this.selected_lga.id}`)
            .then((response) => {
              this.wards = response.data.data;

              console.log(response);
              this.isLoading = false;
            })
            .catch((error) => {
              console.error(error);
              this.isLoading = false;
            });
          //end of get wards
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },

    getClients() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getAgencyToUser/${this.user.institutional_id}`)
        .then((response) => {
          this.clients = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.getClients();
    this.myEnrollees();
  },
};
</script>
<style lang="css" scoped>
.spacer-top {
  margin-top: 10px;
}
</style>
